import Footer from "../../components/Footer/Footer";
import SideBar from "../../components/SideBar/SideBar";
import NavBar1 from "../../components/Navbar1/NavBar1";
import HomeProducts from "../../components/HomeProducts/HomeProducts";
import Banner1 from "../../components/Banner/Banner1";
import Banner2 from "../../components/Banner/Banner2";
import OurClients from "../../components/OurClients/OurClients";
import Carousel from "../../components/Carousel/Carousel";

const home = () => {
  return (
    <>
      <NavBar1 />
      <SideBar>
        <Footer>
          <Carousel />

          <div id={Math.random() * 100000}>
            <HomeProducts key={Math.random() * 10000} />
          </div>

          <OurClients />
        </Footer>
      </SideBar>
    </>
  );
};

export default home;
